import { Box } from 'components/Box';
import { Byline } from 'components/Byline';
import { H1 } from 'components/Text/H1';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsCategories } from 'modules/cms/components/Categories';
import { getIsContentFullWidthLayout } from 'modules/cms/helpers';

type Props = {
  content: CmsApiPage;
};

export function CmsBodyHeader({ content }: Props) {
  const fullWidthLayout = getIsContentFullWidthLayout({ content });

  return (
    <>
      {content.type === 'POST' &&
        content.categories &&
        content.categories.length > 0 && (
          <Box mb={24}>
            <CmsCategories
              categories={content.categories}
              homePageUrl={
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                content.subsite.homePage && content.subsite.homePage.url
              }
            />
          </Box>
        )}

      <H1 m="0" textAlign={fullWidthLayout ? 'center' : 'left'}>
        {content.title}
      </H1>

      {(content.author || (content.postedDate && content.showDate)) && (
        <Box mt={4}>
          <Byline
            slug={content.author ? content.author.slug : undefined}
            name={content.author ? content.author.name : undefined}
            image={content.author?.image || undefined}
            homePageUrl={
              // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
              content.subsite.homePage && content.subsite.homePage.url
            }
            postedDate={content.postedDate}
            showDate={content.showDate}
          />
        </Box>
      )}
    </>
  );
}
